<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>

            <!-- 默认全局策略 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.firewall1") }}
                </span>
                <div class="main" v-if="this.is_run==0">
                    <el-button @click="tan_switchiptable()"  :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.firewall1_a1") }}</el-button>
                    <el-alert :title="$t('logs.firewall1_a1_a1')" type="error" show-icon :closable="false"></el-alert>

                </div>
                <div class="main" v-if="this.is_run==1">
                    <el-button @click="tan_switchiptable()">{{ $t("logs.firewall1_a_2") }}</el-button>
                    <el-alert :title="$t('logs.firewall1_a1_a2')" type="success" show-icon :closable="false"></el-alert>

                </div>
                <div class="lie" v-loading="loading">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 入方向 -->

                                <td>{{ $t("logs.firewall1_a2") }}:</td>
                                <td>
                                    <p class="fire_out">{{this.dft_input}}</p>

                                </td>
                            </tr>
                            <tr>
                                <!-- 出方向 -->

                                <td>{{ $t("logs.firewall1_a3") }}:</td>
                                <td>

                                    <p class="fire_out">{{this.dft_output}}</p>
                                </td>
                            </tr>
                            <tr>
                                <!-- 是否可转发 -->

                                <td>{{ $t("logs.firewall1_a4") }}:</td>
                                <td>

                                    <p class="fire_out">{{this.dft_forward}}</p>
                                </td>
                            </tr>
                            <tr>
                                <!-- 对外放开访问的端口 -->

                                <td>{{ $t("logs.firewall1_a5") }}:</td>
                                <td>

                                    <p class="fire_out">{{this.allow_port}}</p>
                                </td>
                            </tr>
                            <tr>
                                <!-- 受限端口 -->

                                <td>{{ $t("logs.firewall1_a6") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <p class="fire_out">{{this.dft_input1}}</p>

                                </td>
                            </tr>

                            <tr>
                                <!-- 限制http访问 -->

                                <td>{{ $t("logs.firewall1_a8") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="weblimit">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.firewall1_a9')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- 限制https访问 -->

                                <td>{{ $t("logs.firewall1_a10") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="weblimits">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.firewall1_a11')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click=" tanSend_setting()"  :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- 规则列表 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.firewall2") }}
                </span>
                <div class="main">
                    <p>
                        <el-button @click="tan()"  :disabled="$root.jurisdiction.only_query==0">{{$t("logs.firewall2_a1")}}</el-button>

                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="80"></el-table-column>
                            <el-table-column prop="DIRECTION" :label="$t('logs.firewall2_a2')"></el-table-column>
                            <el-table-column prop="TYPE" :label="$t('logs.firewall2_a3')"></el-table-column>
                            <el-table-column prop="PRO" :label="$t('logs.firewall2_a4')"></el-table-column>
                            <el-table-column prop="PORT" :label="$t('logs.firewall2_a5')"></el-table-column>
                            <el-table-column prop="REMOTE_IP" :label="$t('logs.firewall2_a6')" width="300"></el-table-column>
                            <el-table-column prop="IPTABLE_RULE" :label="$t('logs.firewall2_a7')"></el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->
                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small"  :disabled="$root.jurisdiction.only_query==0"> {{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--   规则列表 -->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.firewall2_a1')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text">
                                    <!-- 端口 -->

                                    {{ $t("logs.firewall2_a5") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="port" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text">
                                    <!-- 源IP地址 -->
                                    {{ $t("logs.firewall2_a10") }} :

                                </div>
                                <div class="block block1">
                                    <el-input v-model="host" placeholder=""></el-input>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text">
                                    <!-- 协议 -->

                                    {{ $t("logs.firewall2_a4") }}:
                                </div>
                                <div class="block block1">
                                    <el-select v-model="proto" placeholder="请选择">
                                        <el-option v-for="item in proto_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text">
                                    <!-- 方向 -->

                                    {{ $t("logs.firewall2_a2") }}:

                                </div>
                                <div class="block block1" style="display: flex;align-items: center;">
                                    <el-radio-group v-model="direct">
                                        <el-radio :label="1">{{ $t("logs.firewall2_a11") }}</el-radio>
                                        <el-radio :label="2">{{ $t("logs.firewall2_a12") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text">
                                    <!-- 规则 -->

                                    {{ $t("logs.firewall2_a7") }}:
                                </div>
                                <div class="block block1" style="display: flex;align-items: center;">
                                    <el-radio-group v-model="iptable_rule">
                                        <el-radio :label="1">{{ $t("logs.firewall2_a8") }}</el-radio>
                                        <el-radio :label="2">{{ $t("logs.firewall2_a9") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend_table2()" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            proto_arr: [],
            is_run: '',
            weblimits: '',
            weblimit: '',
            proto: 'TCP',
            direct: '1',
            iptable_rule: "1",
            host: "",
            port: '',
            allow_port: '' || '暂无数据',
            dft_forward: '',
            dft_output: '',
            dft_input: '',
            dft_input1: '',
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "TCP",
                    label: "TCP"
                },
                {
                    value: "UDP",
                    label: "UDP"
                }

            ],
            checked: "",
            fileList: [],
            radio: [],
            data_loadok: '',
            loading: false,
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
    },
    methods: {
        tan_switchiptable() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let startornot = ''
            if (this.is_run == 0) {
                startornot = 1
            } else {
                startornot = 2
            }
            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "switchiptable",
                        sid: sid,
                        startornot: startornot,
                        data_loadok: this.data_loadok
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList2()
                        // // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        // this.ipaddr = res.data.ret.result.IPADDR

                        // this.dft_input = res.data.ret.result.dft_input
                        // this.dft_input1 = res.data.ret.result.SSH_PORT_HINT
                        // this.dft_output = res.data.ret.result.dft_output
                        // this.dft_forward = res.data.ret.result.dft_forward
                        // this.weblimit = res.data.ret.result.WEBLIMIT == 1 ? true : false
                        // this.weblimits = res.data.ret.result.WEBLIMITS == 1 ? true : false
                        // this.is_run = res.data.ret.result.is_run

                        // this.data_loadok = res.data.ret.ok
                        // this.allow_port = res.data.ret.alldftinput ? res.data.ret.alldftinput : '未输入';
                        // // this.tls_typee = res.data.ret.q_tls_type

                        // // 

                    }
                })
        },
        // 显示
        tan: function () {
            this.tanchu = true;
            this.direct = 1
            this.iptable_rule = 1
            this.port = ''
            this.host = ''
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 默认全局策略加载
        getFileList2() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_base_iptables",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
            this.loading = true;

                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        this.ipaddr = res.data.ret.result.IPADDR

                        this.dft_input = res.data.ret.result.dft_input
                        this.dft_input1 = res.data.ret.result.SSH_PORT_HINT
                        this.dft_output = res.data.ret.result.dft_output
                        this.dft_forward = res.data.ret.result.dft_forward
                        this.weblimit = res.data.ret.result.WEBLIMIT == 1 ? true : false
                        this.weblimits = res.data.ret.result.WEBLIMITS == 1 ? true : false
                        this.is_run = res.data.ret.result.is_run

                        this.data_loadok = res.data.ret.ok
                        this.allow_port = res.data.ret.alldftinput ? res.data.ret.alldftinput : '未输入';
                        // this.tls_typee = res.data.ret.q_tls_type
                        this.loading = false;

                        // 

                    }
                })
               
        },
        //规则列表保存
        tanSend_table2() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_iptables_rule",
                sid: sid,
                proto: this.proto,
                direct: this.direct,
                iptable_rule: this.iptable_rule,
                port: this.port,
                host: this.host,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.loading = true;
                        this.tanchu = false
                        // this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });

                    }
                })
               

        },
        //规则列表删除
        handleClick1(index, scope) {
            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    this.loading = true
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let port = scope.PORT;
                    let proto = scope.PRO;
                    let direct = scope.NUM_DIRECT;
                    let iptable_rule = scope.NUM_RULE;
                    let host = scope.REMOTE_IP;
                    let str = this.$qs.stringify({
                        __mode: "del_iptables",
                        sid: sid,
                        port: port,
                        proto: proto,
                        direct: direct,
                        iptable_rule: iptable_rule,
                        host: host,

                    });
                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList1();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // 默认规则列表加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_iptables_list",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        // this.ipaddr = res.data.ret.result.IPADDR

                        // this.netmask = res.data.ret.result.NETMASK
                        // this.gateway = res.data.ret.result.GATEWAY
                        // this.dns1 = res.data.ret.result.DNS1
                        // this.dns2 = res.data.ret.result.DNS2
                        // this.network = res.data.ret.result.LDAP_PASSWORD
                        // this.data_loadok_setting = res.data.ret.ok
                        this.fileList = res.data.ret.datalist;

                        this.proto_arr = res.data.ret.q_type

                        // 

                    }
                })
               
        },
        // 默认全局策略保存
        tanSend_setting() {

          this.$save_hint_test();
          this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_base_iptables",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                weblimit: this.weblimit == true ? 1 : 0,
                weblimits: this.weblimits == true ? 1 : 0,

                data_loadok: this.data_loadok

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList2();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
    }
};
</script>

<style lang="less" scoped>
// /deep/ .el-alert__content {
//     padding: 0;
// }

/deep/ .el-input--suffix {
    width: 212px;
}

/deep/ .el-radio-group {
    display: flex;
    align-items: center;
    line-height: 30px;
    height: 30px;
    margin: 4px 0;
}

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 1
.main {
    display: flex;
    align-items: center;
    // border: 1px solid #dcdfe6;
    // background: #f1f1f1;
    margin: 20px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

// .main span {
//     padding-left: 20px;
// }

// input 框高度
/deep/ .el-input__inner {
    height: 26px;
}

// 弹出框1

.el-input {
    // width: 20%;
    padding: 5px 10px 5px 0;
}

// .back div {
//   margin: 0 10px;
// }

// background: #424F63;
// /deep/ .el-tabs__item .is-top {
//     font-size: 12px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
//     padding-left: 20px;
//     border-left: 0px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
//     padding-right: 20px;
// }

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

.find-text {
    padding-right: 10px;
}

.el-alert--error.is-light {

    font-family: PingFangSC-Regular, PingFang SC;
    color: #F23434;
    background: rgba(242, 52, 52, 0.15);
}

.el-alert--success.is-light {

    background: rgba(35, 149, 71, 0.15);
    font-family: PingFangSC-Regular, PingFang SC;
    color: #1DA254;
}
.fire_out{
    padding: 10px 0;
}
</style>
